<template>
  <div class="home-page">
    <div class="wrap" style="padding:30px;text-align:center">
      <div
        data-cdc-widget="healthBot"
        data-cdc-theme="theme1"
        class="cdc-widget-color-white"
        data-cdc-language="en-us"
      ></div>
      <router-link to="/" class="common-btn">Back to JODIGROUP</router-link>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    let s = document.createElement('script')
    s.setAttribute('src', 'https://t.cdc.gov/1M1B')
    document.head.appendChild(s)
  },
}
</script>

<style>
.common-btn {
  padding: 0 44px;
  text-align: center;
  text-decoration: none;
  border: 2px solid #333;
  line-height: 37px;
  color: #333;
  font-size: 14px;
  margin: 20px auto;
  display: block;
  width: 250px;
}
</style>
